// Academy header mega-menu data — Programs dropdown.
// Internal, self-hosted routing — all links resolve to /academy/programs/{slug}.

export const ACADEMY_PROGRAMS_MENU = {
  label: 'Programs',
  href: '/academy/programs',
  featured: {
    title: 'ZHELTA Academy',
    body: 'Practical, expert-led education that prepares learners for in-demand technology and life-skill careers.',
    cta: 'Explore all programs',
    ctaHref: '/academy/programs',
  },
  groups: [
    {
      heading: 'CORE PROGRAMS',
      items: [
        { label: 'IT Certifications',   href: '/academy/programs/it-certification-programs' },
        { label: 'Computer Hardware',   href: '/academy/programs/computer-hardware-system-fundamentals' },
        { label: 'Software Support',    href: '/academy/programs/software-installation-use-support' },
        { label: 'Cybersecurity',       href: '/academy/programs/cybersecurity-awareness-best-practices' },
      ],
    },
    {
      heading: 'DEV & ANALYTICS',
      items: [
        { label: 'Programming',   href: '/academy/programs/programming-software-development' },
        { label: 'IT Logic',      href: '/academy/programs/mathematics-logical-thinking-it' },
        { label: 'Media Literacy', href: '/academy/programs/creative-technology-media-literacy' },
      ],
    },
    {
      heading: 'CAREER & LIFE',
      items: [
        { label: 'Citizenship',          href: '/academy/programs/digital-citizenship-civic-education' },
        { label: 'Communication',        href: '/academy/programs/professional-communication-it-documentation' },
        { label: 'Role-Based Pathways',  href: '/academy/programs/role-based-learning-portals' },
        { label: 'Learning Boost',       href: '/academy/programs/learning-boost-program' },
      ],
    },
  ],
};
